import "./src/scss/gloposnet.scss"
import "bootstrap/dist/js/bootstrap.min"
import "bootstrap-icons/font/bootstrap-icons.min.css"

import React from "react"
import { ThemeContext } from "./src/context/currency-context"
import { GlobalContextProvider } from "./src/context/GlobalContext"
import { QueryClient, QueryClientProvider } from "react-query"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
const queryClient = new QueryClient()
export const wrapPageElement = ({ element, props }) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Leg1OopAAAAAOzvS8P8WOOL_GgHrwcQy8vB6rzQ">
      <QueryClientProvider client={queryClient}>
        <GlobalContextProvider {...props}>
          <ThemeContext>{element}</ThemeContext>
        </GlobalContextProvider>
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  )
}
/* export const onClientEntry = () => {

}
export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
      `This Website has been updated. ` +
      `Reload to display the latest version?`
  )
  if (answer === true) {
      window.location.reload()
  }
} */
